<template>
    <div>
        <div class="alert__modal">
            <div>
                <div class="alert__modal__title">
                    <p>{{title ? title : '알림'}}</p>
                    <span @click="$emit('close')"></span>
                </div>
                <div class="confirm__modal__content">
                    <p class="content">{{content}}</p>
                    <p class="point__content">{{point_content}}</p>
                </div>
                <div class="confirm__modal__bottom float-content">
                    <div @click="$emit('close')" class="cancel__btn">닫기</div>
                    <div @click="$emit('ok')"  class="ok__btn">{{ok_btn || '확인'}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        props: ['title', 'content', 'point_content', 'ok_btn']
    }
</script>
